const setPersonalDetailField = (payload) => ({
  type: "SET_RSA_DUBLICATED_PERSONAL_DETAIL_FIELD",
  payload,
});

const setResidenceField = (payload) => ({
  type: "SET_RSA_DUBLICATED_RESIDENCE_FIELD",
  payload,
});

const setEmployerField = (payload) => ({
  type: "SET_RSA_DUBLICATED_EMPLOYER_FIELD",
  payload,
});

const setNextOfKinField = (payload) => ({
  type: "SET_RSA_DUBLICATED_NEXTOFKIN_FIELD",
  payload,
});

const setPictureField = (payload) => ({
  type: "SET_RSA_DUBLICATED_PICTURE_FIELD",
  payload,
});

const setSignatureField = (payload) => ({
  type: "SET_RSA_DUBLICATED_SIGNATURE_FIELD",
  payload,
});

const setConsentFormField = (payload) => ({
  type: "SET_RSA_DUBLICATED_CONSENT_FORM_FIELD",
  payload,
});

const setBankDetailsField = (payload) => ({
  type: "SET_RSA_DUBLICATED_BANK_DETAILS_FIELD",
  payload,
});

const getUser = (payload) => ({
  type: "GET_RSA_DUBLICATED_USER",
  payload,
});

const setToken = (payload) => ({ type: "SET_RSA_DUBLICATE_TOKEN", payload });

const resetRSAForm = () => ({ type: "RESET_RSA_DUBLICATED_FORM" });

export default {
  setPersonalDetailField,
  setResidenceField,
  setEmployerField,
  setNextOfKinField,
  setPictureField,
  setSignatureField,
  setConsentFormField,
  setBankDetailsField,
  getUser,
  resetRSAForm,
  setToken,
};
